import { render, staticRenderFns } from "./DetailOverview.vue?vue&type=template&id=c4ee48cc&"
import script from "./DetailOverview.vue?vue&type=script&lang=js&"
export * from "./DetailOverview.vue?vue&type=script&lang=js&"
import style0 from "./DetailOverview.vue?vue&type=style&index=0&id=c4ee48cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports